import React, { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useEntryCheckQuery, useAuthByCodeMutation } from "../../generated-types"
import { handleGqlError } from "../../components/utils"
import { useLoginContext } from "../../components/context/LoginContext"
import { MainLayout } from "../../components/layout/MainLayout"

export default () => {
  const { code } = useParams()
  const navigate = useNavigate()
  const { login, isLogined } = useLoginContext()
  const { data, error: entryError } = useEntryCheckQuery({
    variables: { code },
  })

  useEffect(() => {
    if (entryError) {
      handleGqlError(entryError)
      navigate("/")
    }
  }, [entryError])
  const [authByCodeMutation] = useAuthByCodeMutation({ fetchPolicy: "no-cache" })

  useEffect(() => {
    if (isLogined()) {
      navigate("/my")
    }
  }, [])

  useEffect(() => {
    if (!data) return
    if (data.entryCheck.isUsed) {
      authByCodeMutation({ variables: { code } })
        .then((r) => {
          const { username, token, exp } = r.data.authByCode
          login(username, token, exp)
          // TODO redir 파라메터 처리
          navigate("/my")
        })
        .catch(handleGqlError)
    } else {
      navigate(
        data.entryCheck.codeType === "RCODE" ? `/login/${code}/profile` : `/login/${data.entryCheck.ecode}/profile`
      )
    }
  }, [data])

  return <MainLayout loading={true} />
}
